import { render, staticRenderFns } from "./TeamQuestionSlide.vue?vue&type=template&id=4a48ff75&scoped=true"
import script from "./TeamQuestionSlide.vue?vue&type=script&lang=js"
export * from "./TeamQuestionSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a48ff75",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a48ff75')) {
      api.createRecord('4a48ff75', component.options)
    } else {
      api.reload('4a48ff75', component.options)
    }
    module.hot.accept("./TeamQuestionSlide.vue?vue&type=template&id=4a48ff75&scoped=true", function () {
      api.rerender('4a48ff75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/TeamQuestionSlide.vue"
export default component.exports